(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trt-catering"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function rupiah(subunits) {
      var whole = Math.round(Number(subunits) / 100);
      return 'Rp\u00A0' + String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    function initForm(form) {
      if (form.dataset.trtCatReady) return;
      form.dataset.trtCatReady = '1';
      var variant = form.querySelector('[data-trt-cat-variant]');
      var qty = form.querySelector('[data-trt-cat-qty]');
      var minNote = form.querySelector('[data-trt-cat-min-note]');
      var date = form.querySelector('[data-trt-cat-date]');
      var total = form.querySelector('[data-trt-cat-total]');
      var submit = form.querySelector('[data-trt-cat-submit]');
      var errorEl = form.querySelector('[data-trt-cat-error]');
      if (!variant || !qty) return;

      function current() {
        var el = variant.tagName === 'SELECT' ? variant.options[variant.selectedIndex] : variant;
        return { min: parseInt(el.getAttribute('data-min'), 10) || 1, price: Number(el.getAttribute('data-price')) || 0 };
      }

      function update(fromArea) {
        var c = current();
        qty.min = c.min;
        var q = parseInt(qty.value, 10);
        if (fromArea && (!q || q < c.min)) { qty.value = c.min; q = c.min; }
        if (minNote) minNote.textContent = 'Minimum ' + c.min + ' guests';
        qty.setCustomValidity(q >= c.min ? '' : 'Minimum ' + c.min + ' guests for this delivery area.');
        if (total) {
          total.textContent = q > 0
            ? q + '\u00A0guests × ' + rupiah(c.price) + ' = ' + rupiah(c.price * q)
            : '';
        }
      }

      if (date) {
        var lead = parseInt(date.getAttribute('data-lead-days'), 10) || 3;
        // Earliest date in Bali time (Asia/Makassar), the same zone the cart guard
        // uses server-side, never the visitor's clock. UTC date math avoids any
        // local-timezone off-by-one. On any failure the server-set min stays.
        try {
          var baliToday = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Makassar' }).format(new Date());
          var parts = baliToday.split('-');
          if (parts.length === 3) {
            var u = new Date(Date.UTC(+parts[0], +parts[1] - 1, +parts[2] + lead));
            date.min = u.toISOString().slice(0, 10);
          }
        } catch (err) { /* keep server-set min */ }
        var checkDate = function () {
          date.setCustomValidity(date.value && date.value < date.min
            ? 'Please choose a date at least ' + lead + ' days from today.'
            : '');
        };
        date.addEventListener('input', checkDate);
        date.addEventListener('change', checkDate);
      }

      if (variant.tagName === 'SELECT') variant.addEventListener('change', function () { update(true); });
      qty.addEventListener('input', function () { update(false); });
      qty.addEventListener('change', function () { update(false); });
      update(true);

      form.addEventListener('submit', function (e) {
        update(false);
        if (date) date.dispatchEvent(new Event('change'));
        if (!form.checkValidity()) {
          e.preventDefault();
          form.reportValidity();
          return;
        }
        if (errorEl) errorEl.hidden = true;
        if (submit) {
          submit.setAttribute('aria-disabled', 'true');
          submit.classList.add('loading');
        }
      });
    }

    function hideFloatWhileCardsVisible() {
      var grids = document.querySelectorAll('[data-trt-cat-grid]');
      if (!grids.length || !('IntersectionObserver' in window)) return;
      var visible = new Set();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target);
        });
        document.documentElement.classList.toggle('trt-cat-cards-in-view', visible.size > 0);
      });
      grids.forEach(function (g) { io.observe(g); });
    }

    function init() {
      document.querySelectorAll('form[data-trt-cat-form]').forEach(initForm);
      hideFloatWhileCardsVisible();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
